import { createContext, useContext, useState, useEffect } from "react";

type Theme = "dark" | "light";

interface ThemeCtx {
	theme: Theme;
	toggleTheme: () => void;
	isDark: boolean;
}

const ThemeContext = createContext<ThemeCtx>({
	theme: "light",
	toggleTheme: () => {},
	isDark: false,
});

export function ThemeProvider({ children }: { children: React.ReactNode }) {
	const theme: Theme = "light";

	useEffect(() => {
		document.documentElement.setAttribute("data-theme", "light");
		localStorage.setItem("spartech_theme", "light");
	}, []);

	const toggleTheme = () => {};

	return (
		<ThemeContext.Provider value={{ theme, toggleTheme, isDark: false }}>
			{children}
		</ThemeContext.Provider>
	);
}

export function useTheme() {
	return useContext(ThemeContext);
}
